export const namespaced = true

export const state = {
  isNotificationPermission: false,
  isSystemNotificationApproved: false
}

export const mutations = {
  UPDATE_NOTIFICATION_PERMISSON(state, value) {
    state.isNotificationPermission = value
  },
  UPDATE_SYSTEM_NOTIFICATION_APPROVAL(state, value) {
    state.isSystemNotificationApproved = value
  }
}
